import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=32259c79"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32259c79')) {
      api.createRecord('32259c79', component.options)
    } else {
      api.reload('32259c79', component.options)
    }
    module.hot.accept("./TagInput.vue?vue&type=template&id=32259c79", function () {
      api.rerender('32259c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/common/TagInput.vue"
export default component.exports